import React from 'react';

import { VehiclePlace } from 'models/auto/vehicleSearch';

import Result from './styles';

export interface Props {
  data: VehiclePlace;
  onClick: (data: VehiclePlace, isCity?: boolean) => void;
}

const ResultPlace = ({ data, onClick }: Props) => (
  <Result onClick={() => onClick(data, false)}>
    <Result.info>
      <Result.SubTitle>
        <Result.icon />
        {data.description}
      </Result.SubTitle>
    </Result.info>
  </Result>
);

export default ResultPlace;
